import request from '@/utils/request'

let FengtanApi = {
  /*文章列表*/
  fenglist(data, errorback) {
    // return request._post('/shop/plus.feng.feng/index1', data, errorback);
    return request._post('/shop/plus.feng.feng/index', data, errorback);
  },
  /*封坛详情*/
  fengDetail(data, errorback) {
    return request._post('/shop/plus.feng.feng/detail', data, errorback);
  },
  /*回寄封坛条详情*/
  ArticleFengTan(data, errorback) {
    return request._post('/shop/plus.feng.feng/fengArticle', data, errorback);
  },
  /*确认封坛*/
  FengTan(data, errorback) {
    return request._post('/shop/plus.feng.feng/fengTan', data, errorback);
  },





}
export default FengtanApi;



// WEBPACK FOOTER //
// ./src/api/fengtan.js